import { render } from "./PerformanceProductTableGroupBy.vue?vue&type=template&id=7040e1de"
import script from "./PerformanceProductTableGroupBy.vue?vue&type=script&lang=js"
export * from "./PerformanceProductTableGroupBy.vue?vue&type=script&lang=js"

import "./PerformanceProductTableGroupBy.vue?vue&type=style&index=0&id=7040e1de&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__